module.exports = __webpack_public_path__ + "static/assets/2be1a9bef13cda38a249cfa6de0dc461.svg";